<template>
    <Head>
        <title>Wakaf Pahang - Wakaf dalam talian</title>
        <link rel="shortcut apple-touch-icon icon" :href="img_favicon" type="image/png">
    </Head>
    <header class="container-fluid p-2 bg-wakaf-primary">
        <div class="container-md d-flex flex-wrap">
            <div class="d-flex flex-wrap justify-content-center">
                <img :src="img_wakafpahang" class="mx-3" width="200" height="57" alt="Selamat datang ke Wakaf Pahang" />
                <div class="d-flex flex-column align-items-md-max-center">
                    <span class="fs-6 text-white">Pembayaran wakaf dalam talian bagi  {{ info.nama }}</span>
                    <span class="fs-6 text-white">Semai di dunia, tuai di akhirat</span>
                    <a href="tel:609514151" class="fs-6 text-white"><font-awesome-icon :icon="faPhone" class="me-1" /> 09-514 5151</a>
                </div>
            </div>
        </div>
    </header>
    <section class="container" style="margin-bottom: 300px">
        <form @submit.prevent="submitForm">
            <div class="row mt-3">
                <div class="col-lg-12 mt-md-4">
                    <div class="d-flex flex-column">
                        <span class="fs-6 fst-italic">Sila tekan butang <b>Tambah</b> untuk tambah bilangan wakaf.</span>
                        <span class="fs-6 fst-italic">Setiap pembayaran melalui FPX akan dikenakan cas sebanyak 50 sen</span>
                    </div>
                    <transaction-public ref="wakafDataRef" :wakaf_type='wakaf_type' :wakaf_district='wakaf_district' :wakaf_project='wakaf_project'
                                :nama_pewakaf="info.nama" :w_id="data.wid" :d_id="data.did" :p_id="data.pid"
                                @calulate-sum="calculateSum" :userdata='userdata'></transaction-public>
                    <div class="d-flex justify-content-between mt-3">
                        <button class="btn btn-danger px-4" :class="{'d-none': hideCloseBtn}" @click="cancelFormSubmit"
                                type="button"><i class="fa-solid fa-xmark"></i>&nbsp;&nbsp;Batal
                        </button>
                        <span v-if="isDisplayGrandSumAndSubmit" class="fs-6 fw-bold btn btn-outline-primary">Jumlah keseluruhan :{{ sumFormat(sum) }}</span>
                        <button v-if="isDisplayGrandSumAndSubmit" class="btn btn-success px-4" style="right: 0" type="submit"><font-awesome-icon :icon="faPaperPlane" />&nbsp;&nbsp;Hantar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </section>
    <footerFPX :year="currentYear"></footerFPX>
</template>

<script setup lang="ts">
import {Head} from "@inertiajs/vue3";
import {sumFormat} from "../../utils/utils"
import {onMounted, Ref, ref} from "vue";
import axios from "axios";
import Swal from "sweetalert2";
import transactionPublic from "./transactionPublic.vue";
import FooterFPX from "./footerFPX.vue";
import {faPaperPlane, faPhone} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import type {FormGeneral} from "../interface/FormGeneral";
library.add( faPaperPlane);

const data = defineProps<{
    currentYear: number,
    img_fpx: string,
    img_wakafpahang: string,
    img_favicon: string,
    img_wakafconfrim: string,
    csrf: string,
    submit_url: string,
    ezid_logo: string,
    info: {
        nama: string,
        telefonbimbit: string,
        daerah: string,
        nokp: string,
        emel: string
    },
    district: [{
        KodDaerah: number,
        Daerah: string,
    }],
    wakaf_type: [{
        id: number,
        Nama: string,
    }],
    wakaf_district: [{
        KodDaerah: number,
        WakafJenisID: number,
        daerah: string,
    }],
    wakaf_project: [{
        kod: number,
        nama: string,
        WakafJenisID: number,
        DaerahID: number,
    }],
    wid?: number,
    did?: number,
    pid?: number | string, // due to HBHD and gabby
    userdata?: [{
        ID: number,
        JenisWakaf: number,
        KodDaerah: number,
        Projek: number,
        Unit: number,
        JenisPemilikan: string,
        NamaPemilik: string,
        Amaun: number,
        NoResitt: number,
        WakafResitID: number
    }],
}>();

const sum: Ref = ref<number>();
const hideCloseBtn: Ref = ref<boolean>(true);
const wakafDataRef: Ref = ref<InstanceType<typeof transactionPublic> | null>(null);
const isDisplayGrandSumAndSubmit: Ref = ref<boolean>(false);

const submitForm = (): void => {
    Swal.fire({
        title: "Anda pasti untuk hantar?",
        html: `<p class="fs-6">Saya dengan ini mewakafkan nilai sebanyak <b> ${sumFormat(sum.value)}</b> selama-lamanya kerana Allah Ta'ala</p>
                    <p style="font-size: 12px" class="fst-italic">Tiada caj pengurusan akan diambil terhadap amaun wakaf. Pihak pengurusan hanya diizinkan mengambil caj pengurusan daripada hibah / keuntungan deposit wang wakaf (jika ada) pada kadar tidak melebihi separuh amaun hibah / keuntungan deposit.</p>
                   `,
        imageUrl: data.img_wakafconfrim,
        imageWidth: 128,
        imageHeight: 128,
        imageAlt: "https://scontent.fkul8-1.fna.fbcdn.net/v/t39.30808-6/273934690_502048671273505_7724223417660615651_n.jpg?_nc_cat=108&ccb=1-7&_nc_sid=09cbfe&_nc_ohc=qovDre6CzQAAX9lAgpE&_nc_ht=scontent.fkul8-1.fna&oh=00_AT9duT49qOrl9u0V5fVc3mFTWd8j4O6WYi2w-FM0LJQ7eA&oe=63424A82",
        showConfirmButton: true,
        confirmButtonColor: "#198754",
        confirmButtonText: "Ya, saya wakafkan",
        showCancelButton: true,
        cancelButtonText: "Kembali",
        cancelButtonColor: "#0d6efd",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        reverseButtons: true,
        preConfirm: () => {
            // return 0
            let jenisWakaff : number[] = [];
            let daerahWakaff : number[] = [];
            let projekWakaff : number[] = [];
            let unitt : number[] = [];
            let jumlahh : number[] = [];
            let jenisPemilikk : string[] = [];
            let namaPemilikk : string[] = [];
            wakafDataRef.value?.transactionPublic.forEach((item:FormGeneral) => {
                jenisWakaff.push(item.jenisWakaf);
                daerahWakaff.push(item.daerahWakaf);
                projekWakaff.push(item.projekWakaf);
                unitt.push(item.unit);
                jumlahh.push(item.jumlah);
                jenisPemilikk.push(item.jenisPemilik);
                namaPemilikk.push(item.namaPemilik);
            })
            return axios({
                method: "post",
                url: data.submit_url,
                data: {
                    csrf: data.csrf,
                    jenisWakaf: jenisWakaff,
                    daerahWakaf: daerahWakaff,
                    projekWakaf: projekWakaff,
                    unit: unitt,
                    jumlah: jumlahh,
                    jenisPemilik: jenisPemilikk,
                    namaPemilik: namaPemilikk,
                }
            }).then(function (response) {
                window.location.href = response.data;
            }).catch(function (error) {
                Swal.fire({
                    icon: "error",
                    title: "Ralat berlaku",
                    text: "Sila cuba semula untuk hantar. " + error.body.message,
                    timer: 5000,
                    timerProgressBar: true,
                    confirmButtonColor: "#0d6efd",
                    confirmButtonText: "Ok",
                })
            });


        },
    })

}
const calculateSum = (summ: number) : void =>{
    if(wakafDataRef.value.transactionPublic.length === 0) {
        isDisplayGrandSumAndSubmit.value = false;
        sum.value = 0;
    } else if (wakafDataRef.value.transactionPublic.length > 0) {
        isDisplayGrandSumAndSubmit.value = true;
        sum.value = summ;
    }
}

const cancelFormSubmit = () => {
    Swal.fire({
        position: "top",
        icon: "question",
        title: "Anda pasti untuk batal?",
        showConfirmButton: true,
        confirmButtonColor: "#dc3545",
        confirmButtonText: "Ya",
        showCancelButton: true,
        cancelButtonText: "Kembali",
        cancelButtonColor: "#0d6efd"
    }).then((result) => {
        if (result.isConfirmed) {
            window.close()
        }
    })
}
onMounted(() => {
    if (window.opener !== null) {
        hideCloseBtn.value = false;
    }
    wakafDataRef.value.openAddModal();
});
</script>

<style scoped>

</style>
